import { HttpParams } from "@angular/common/http";
import { Inject, Injectable, forwardRef } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { firstValueFrom } from "rxjs";
import { DATA_IMPORTS, DATA_IMPORTS_V2 } from "../../common/endpoints";
import { DataImport, PagedList } from "../../model";
import { CustomLabelService } from "../../service/custom-label.service";
import { HttpService } from "../../service/http.service";
import { AbstractContextService } from "../../shared/class/abstract-context-service.class";
import { AbstractThingContextService } from "../../shared/class/abstract-thing-context-service.class";
import { LocalizationPipe } from "../../shared/pipe";

@Injectable()
export class DataImportWidgetService {

    constructor(
        @Inject(forwardRef(() => HttpService)) private httpService: HttpService,
        @Inject(forwardRef(() => AbstractContextService)) private contextService: AbstractContextService,
        @Inject(forwardRef(() => AbstractThingContextService)) private thingContextService: AbstractThingContextService,
        @Inject(forwardRef(() => CustomLabelService)) private labelService: CustomLabelService,
        @Inject(forwardRef(() => MatSnackBar)) private snackBar: MatSnackBar,
        @Inject(forwardRef(() => LocalizationPipe)) private localizationPipe: LocalizationPipe
    ) { }

    getPagedDataImports(sort: string[], pageIndex: number, pageSize: number): Promise<PagedList<DataImport>> {
        const params = this.getParams(sort, pageIndex, pageSize);
        return firstValueFrom(this.httpService.get<PagedList<DataImport>>(DATA_IMPORTS_V2, params));
    }

    private getParams(sort: string[], pageIndex: number, pageSize: number): HttpParams {
        let params = new HttpParams();
        params = params.set('page', pageIndex + '');
        params = params.set('size', pageSize + '');
        if (sort && sort[0]) {
            params = params.set('sort', sort.join(','));
        }
        params = params.set('thingId', this.thingContextService.getCurrentThing().id);
        return params;
    }

    showSnackbar(text: string, isError?: boolean): void {
        this.labelService.getCustomLabel(text)
            .then(message => {
                this.snackBar.open(this.localizationPipe.transform(message), '', {
                    duration: 4000,
                    panelClass: isError ? 'notification-error' : 'notification-info'
                });
            });
    }

    performDataImport(formData: FormData): Promise<DataImport> {
        const currentThing = this.thingContextService.getCurrentThing();
        const params = new HttpParams().set('thingId', currentThing.id);
        return firstValueFrom(this.httpService.post<DataImport>(DATA_IMPORTS, formData, params));
    }

}